import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { ConfirmationModalInterface } from "../../types/confirmation_modal";

const ConfirmationModal: React.FC<ConfirmationModalInterface> = ({
    onCancel,
    onSave,
    message,
    isSaving,
    isEditing,
}) => {
    return (
        <div className="absolute bottom-0 mb-10 left-1/2 transform -translate-x-1/2 flex md:space-x-4 flex-col md:flex-row items-center justify-center p-2 bg-gray-200 w-4/5 md:w-1/3 rounded-xl">
            <div className="flex text-sm font-bold mb-2 md:mb-0 mr-4">
                {message}
            </div>
            <div className="flex space-x-4 md:pl-4 md:ml-4">
                <button
                    className="p-2 bg-gray-400 text-white text-sm rounded-full z-50"
                    onClick={onCancel}
                >
                    Annuler
                </button>
                <Button
                    onClick={onSave}
                    disabled={!isEditing || isSaving} // Disable when not editing or saving
                    sx={{
                        borderRadius: "999px",
                        backgroundColor: isEditing ? "#C3FF36" : "gray",
                        color: "black",
                        textTransform: "none",
                        "&:disabled": {
                            backgroundColor: "lightgray",
                            color: "darkgray",
                        },
                    }}
                >
                    {isSaving ? (
                        <CircularProgress size={16} sx={{ color: "black" }} />
                    ) : (
                        "Enregistrer"
                    )}
                </Button>
            </div>
        </div>
    );
};

export default ConfirmationModal;
